/**
 * Decode JWT payload (no signature verification — for UI hints only; API enforces auth).
 */
export function decodeJwtPayload(token: string | null | undefined): Record<string, unknown> | null {
  if (!token?.trim()) return null;
  try {
    const parts = token.split('.');
    if (parts.length < 2) return null;
    const json = atob(parts[1].replace(/-/g, '+').replace(/_/g, '/'));
    return JSON.parse(json) as Record<string, unknown>;
  } catch {
    return null;
  }
}
